// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"backdrop_Backdrop__2h_C1"};